import angular from 'angular';

module.exports = angular.module('common.directives.dropdown_multiselect', [])
.directive('ocDropdownMultiselect', function() {
  return {
    restrict: 'C',
    scope: {
      providedModel: '=',
      options: '=',
      orderBy: '@',
      dropdownAlign: '@',
      onChange: '&',
      // Can be 'medium' or 'small', defaults to 'small'
      size: '@'
    },
    templateUrl: '/templates/common/directives/dropdown_multiselect.html',
    controller: function($scope, dropdownLabel) {
      $scope.dropdownLabel = dropdownLabel;
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/dropdown-multiselect.js
 **/